import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const DocumentCategoryList = Loadable(lazy(() => import('./DocumentCategoryList')));
const AddDocumentCategory = Loadable(lazy(() => import('./AddDocumentCategory')));

const DocumentCategoryRoutes = [
	{
		path: '/documentcategory/list',
		element: <DocumentCategoryList />,
		auth: authRoles.admin,
	},
	{
		path: '/documentcategory/manage',
		element: <AddDocumentCategory />,
		auth: authRoles.admin,
	},
];

export default DocumentCategoryRoutes;
